import apiClient from 'utilities/apiClient';

export const setpassword = (payload) => {
  return apiClient.post(`${apiClient.Urls.setPassword}`, payload);
};
